module.exports = __webpack_public_path__ + "static/media/homeVideo1.32a5cd43.png";